import { ActivatedRouteSnapshot } from '@angular/router';

/**
 * Loop through snapshots, looking for one with a non-null routeConfig
 * property with a path attribute that matches our target parental path,
 * returning either the data attached or (for safety) an empty object.
 *
 * @param activeSnapshots - An array of active route snapshots.
 * @param targetParent - The target parental path segment.
 */
export function getParentSnapshotData(
  activeSnapshots: ActivatedRouteSnapshot[],
  targetParent: string
): any {
  return (
    activeSnapshots.find(
      (snapshot) => snapshot.routeConfig?.path === targetParent
    )?.data ?? {}
  );
}

/**
 * Loop through snapshots, looking for one with a non-null param matching
 * the requested param name.
 *
 * @param activeSnapshots - An array of active route snapshots.
 * @param paramName - The param to seek. Defaults to `id`.
 */
export function getParentSnapshotParam(
  activeSnapshots: ActivatedRouteSnapshot[],
  paramName = 'id'
): string {
  return (
    activeSnapshots.find((snapshot) => snapshot?.params?.id)?.params?.[
      paramName
    ] ?? undefined
  );
}
